"use client"

import { useState } from "react"
import { useTheme } from "./theme-provider"

export default function Textbox({ onAddActivity }) {
  const [activity, setActivity] = useState("")
  const { theme } = useTheme()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (activity.trim()) {
      onAddActivity(activity)
      setActivity("")
    }
  }

  // Updated suggestions to include more language-related activities
  const suggestions = [
    "speaking",
    "reading a book",
    "listening to music",
    "writing an essay",
    "learning a language",
    "giving a speech",
    "having a conversation",
    "translating text",
  ]

  const handleSuggestionClick = (suggestion) => {
    onAddActivity(suggestion)
    setActivity("")
  }

  return (
    <div className="textbox-container">
      <form className="activity-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            value={activity}
            onChange={(e) => setActivity(e.target.value)}
            placeholder="Enter an activity (e.g., 'speaking', 'reading a book')"
            aria-label="Activity input"
            style={{
              backgroundColor: theme === "dark" ? "var(--bg-tertiary)" : "",
              color: theme === "dark" ? "var(--text-primary)" : "",
              borderColor: theme === "dark" ? "var(--border-color)" : "",
            }}
          />
          <button 
            type="submit" 
            className="btn btn-primary analyze-btn-vibrant" 
            disabled={!activity.trim()}
            style={{
              background: 'linear-gradient(135deg, #06ffa5 0%, #00d4aa 100%)',
              color: '#000',
              fontWeight: '800',
              fontSize: '1.05rem',
              padding: '1.25rem 2.5rem',
              border: 'none',
              borderRadius: '15px',
              transition: 'all 0.3s ease',
              cursor: activity.trim() ? 'pointer' : 'not-allowed',
              opacity: activity.trim() ? '1' : '0.6'
            }}
          >
            Analyze Brain Activity
          </button>
        </div>
        <div className="suggestions mt-2">
          <span className="text-muted me-2">Try:</span>
          {suggestions.map((suggestion, index) => (
            <button
              key={index}
              type="button"
              className="btn btn-sm btn-outline-primary me-1 mb-1"
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {suggestion}
            </button>
          ))}
        </div>
      </form>
    </div>
  )
}
